import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { setHomePageData } from 'redux/actions/homePageActions';
import { setRefresh } from 'redux/actions/pageActions';

// axios
import axios from 'axios';
import { apiClient } from "api-client"

// helper
import { generateSearchQuery } from 'utils';

// language
import { injectIntl, IntlShape } from 'react-intl';

// compoments
import LoadingComponent from 'components/LoadingComponent';
import ErrorComponent from 'components/ErrorComponent';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import HomePageCard from 'components-lib/HomePageCard'

// @mui material components
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';

// icons
import {
  containerIcon,
  usersIcon,
  incomeIcon,
  orderIcon,
  reservationIconWhite,
  kayakWhiteIcon,
  containerDoorGreyIcon,
  signalIcon,
  kayakIcon,
  reservationIconGrey,
} from 'assets/icons';

// types
import { HomePageState, Refresh } from 'types/typesRedux';

type Props = {
  intl: IntlShape,
}

const HomePage = ( {intl}: Props ) => {

  const dispatch = useDispatch();

  // take data from redux
  const homePageData = useSelector( (state: HomePageState) => state.homePage.homePage );
  const refresh = useSelector( (state: Refresh) => state.handleRefresh);

  const [ localLoading, setLocalLoading ] = useState(true);
  
  const [ isError, setIsError ] = useState(false);

  const getAllStats = async ( ) => {

    const cancelToken = axios.CancelToken.source()

    try{
      const response = await apiClient.get("/v1/stats",{
        cancelToken:cancelToken.token
      });

      if (response) {
        dispatch(setHomePageData({ ...response.data }));
        if (isError === true) {setIsError(false);
        };
      } else {
        console.log("No response received.");
      }
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("canceled");
      } else {
        setIsError(true);
      }
    }
    setLocalLoading(false);
    // handleRefreshPage();
    if ( refresh.refresh === true ) { dispatch(setRefresh( { refresh: false } )) };
    return () => cancelToken.cancel()
  };

  useEffect(() => {
    async function fetchData() {
      await getAllStats();
      // await getItemsStats();
      // await getContainers();
    }
    fetchData();
  }, []);

  // Refresh page if refresh is true
  useEffect(() => {
    async function fetchData() {
      await getAllStats();
      // await getItemsStats();
      // await getContainers();
    }
    fetchData();
  }, [ refresh.refresh ])

  const handleContainerDoorStatus = ( doorStatusA: string, doorStatusB: string ) => {
    if (doorStatusA === "closed" && doorStatusB === "closed") {
      return '#309B0A';
    } else if (doorStatusA === "opened" || doorStatusB === "opened") {
      return '#F5A524';
    } else if (doorStatusA === "unknown" || doorStatusB === "unknown") {
      return '#7B809A';
    } else {
      return '#DD2626';
    }
  };

  const handleContainerDoorStatusTooltip = ( doorStatusA: string, doorStatusB: string ) => {
    if (doorStatusA === "closed" && doorStatusB === "closed") {
      return intl.formatMessage({id:'tableContainers.tooltip.doorSuccess'});
    } else if (doorStatusA === "opened" || doorStatusB === "opened") {
      return intl.formatMessage({id:'tableContainers.tooltip.doorWarningHomePage'});
    } else if (doorStatusA === "unknown" || doorStatusB === "unknown") {
      return intl.formatMessage({id:'tableContainers.tooltip.unknown'});
    } else {
      return intl.formatMessage({id:'tableContainers.tooltip.doorError'});
    }
  };

  const handleContainerConnectionStatus = ( bool: boolean ) => {
    if ( bool === true ) {
      return '#309B0A';
    } else if ( bool === false ) {
      return '#DD2626';
    }
  };

  const handleContainerConnectionStatusTooltip = ( bool: boolean ) => {    
    if ( bool === true ) {
      return 'Online';
    } else if ( bool === false ) {
      return 'Offline';
    }
  };

  const handleRefresh = () => {
    dispatch(setRefresh( { refresh: true } ));
  }

  if ( isError ) {
    return <ErrorComponent onPress={handleRefresh} />;
  }

  if ( localLoading ) {
    return <LoadingComponent />;
  }
// #d9fbda
  return (
    <MDBox
      sx={{ marginLeft: "max(18.7rem)", paddingRight: "1rem", width: "auto",
      display: "flex", flexDirection: "row", marginTop: "5rem",
      maxWidth: "82rem", gap: "2.5rem",
      }}
    >
      <MDBox
        className= "containerHomePageCard"
      >
        <MDBox
          className= "containerHomePageBoxesfirst"
        >
          <HomePageCard
            key="users"
            nameCard={'users'}
            icon={usersIcon}
            homePageData={homePageData} 
          />

          <HomePageCard
            key="income"
            nameCard={'income'}
            icon={incomeIcon}
            homePageData={homePageData} 
          />
        
          <HomePageCard
            key="boats"
            nameCard={'boats'}
            icon={kayakWhiteIcon}
            homePageData={homePageData} 
          />
        </MDBox>
        <MDBox
          className= "containerHomePageBoxesSecond"
        >
          <HomePageCard
            key='orders'
            nameCard={'orders'}
            icon={orderIcon}
            homePageData={homePageData} 
          />

          <HomePageCard
            key='reservations'
            nameCard={'reservations'}
            icon={reservationIconWhite}
            homePageData={homePageData} 
          />
        </MDBox>
      </MDBox>
      
      {/* containers card */}
      <MDBox
        sx={{
          display: "flex", flexDirection: "column",
          gap: "0.9rem", minWidth: "21rem",
        }}
      >
        <MDBox        
          sx= {{ width: "100%", display: "flex",
            flexDirection: "column", gap: "1rem",
            padding: "0.8rem 1.5rem 1.2rem 1.5rem", backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
          }}
        >

          <MDBox
              sx= {{ 
                  width: "100%", display: "flex", flexDirection: "column",                
              }}
          >
            <MDBox 
              sx= {{ 
                  width: "100%", display: "flex", flexDirection: "row", 
                  gap: "1rem",
              }}
            >
              <MDBox className= "badge"
                sx={{ 
                  // backgroundColor: "#17C063",
                  p: 1, mt: -4, ml: 0,
                  borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl, 
                }}
                display="grid"
                justifyContent="center"
                alignItems="center"
                bgColor="#17C063"
                color="white"
                width="4.5rem"
                height="4.5rem"
                shadow="md"
                borderRadius="lg"
                variant="gradient"  
                fontSize= "2.2rem"        
              >
                {containerIcon}
              </MDBox>
              <MDBox
                sx={{
                  display: "flex", flexDirection: "column",
                  justifyContent: "flex-end",
                }}
              >
                <MDTypography
                  sx={{
                    fontSize: "1.2rem", fontWeight: "700",
                  }}
                >
                  {intl.formatMessage({id:'homePage.containers'})}
                </MDTypography>
              </MDBox>
            </MDBox>

            <MDBox
              sx={{
                display: "flex", flexDirection: "column",
                paddingTop: "0.9rem",
              }}
            >
              <MDBox
                sx={{
                  display: "flex", flexDirection: "row",
                  justifyContent: "space-between", alignItems: "center",
                  paddingTop: "0.4rem", paddingBottom: "0.3rem",
                  width: "100%"
                }}
              >
                <MDBox
                  sx={{
                    minWidth: "4rem",
                    display: "flex", flexDirection: "row",
                    gap: "0.7rem"
                  }}
                >
                  <MDBox
                    sx={{
                      width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    {containerDoorGreyIcon}
                  </MDBox>
                  <MDBox
                    sx={{
                      width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    {signalIcon}
                  </MDBox>
                </MDBox>
                
                <MDTypography
                  sx={{
                    minWidth: "10rem", display: "flex",
                    flexDirection: "row", justifyContent: "flex-start",
                    fontSize: "0.75rem", fontWeight: "700",
                    color: "#807E7B", marginLeft: "0.45rem",
                  }}
                >
                  {intl.formatMessage({id:'homePage.name'})}
                </MDTypography>

                <MDBox
                  sx={{
                    minWidth: "3.5rem",
                    display: "flex", flexDirection: "row",
                    justifyContent: "flex-end", gap: "0.3rem"
                  }}
                >
                  <MDBox
                    sx={{
                      width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    {kayakIcon}
                  </MDBox>
                  <MDBox
                    sx={{
                      width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    {reservationIconGrey}
                  </MDBox>
                </MDBox>

              </MDBox>
              <Divider
                orientation="horizontal"
                flexItem
                sx={{ 
                  width: '100%', height: '1px', marginTop: "0.3rem", 
                  marginBottom: "0rem", background: 'black',
                }}
              />
            </MDBox>

            { homePageData.containers.map((container: any) => {
              return (
                <MDBox
                key={container.id}
                  sx={{
                    display: "flex", flexDirection: "row",
                    justifyContent: "space-between", alignItems: "center",
                    paddingTop: "0.4rem", width: "100%"
                  }}
                >

                <MDBox
                  sx={{
                    minWidth: "4rem",
                    display: "flex", flexDirection: "row",
                    gap: "0.7rem"
                  }}
                >
                  <Tooltip title={handleContainerDoorStatusTooltip(container.doorA, container.doorB)}>
                    <MDBox
                      sx={{
                        width: "50%",
                        display: "flex", flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <MDBox
                        sx={{
                          width: "0.75rem", height: "0.75rem",
                          borderRadius: "50%", backgroundColor: handleContainerDoorStatus(container.doorA, container.doorB),
                        }}
                      />
                    </MDBox>
                  </Tooltip>
                  <Tooltip title={handleContainerConnectionStatusTooltip(container.isOnline)}>
                    <MDBox
                      sx={{
                        width: "50%",
                        display: "flex", flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <MDBox
                        sx={{
                          width: "0.75rem", height: "0.75rem",
                          borderRadius: "50%", backgroundColor: handleContainerConnectionStatus(container.isOnline),
                        }}
                      />
                    </MDBox>
                  </Tooltip>
                </MDBox>

                <MDBox
                  sx={{
                    display: "flex", flexDirection: "row",
                    justifyContent: "flex-start", minWidth: "10rem",
                    marginLeft: "0.45rem", marginRight: "0.35rem",
                  }}
                >
                  <MDTypography
                    sx={{
                      fontSize: "0.875rem", fontWeight: "400",
                      color: "#1D1C1B", wordBreak: "keep-all",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {container.name}
                  </MDTypography>
                </MDBox>

                <MDBox
                  sx={{
                    minWidth: "3.5rem",
                    display: "flex", flexDirection: "row",
                    justifyContent: "flex-end", gap: "0.3rem"
                  }}
                >
                  {/* <Tooltip title={intl.formatMessage({id:'homePage.tooltip.availableBoats'})}> */}
                    <MDBox
                      sx={{
                        width: "50%",
                        display: "flex", flexDirection: "row",
                        justifyContent: "center",
                        fontSize: "0.875rem", fontWeight: "400",
                        color: "#1D1C1B",
                      }}
                    >
                      {container.boats.available}
                    </MDBox>
                  {/* </Tooltip> */}

                  {/* <Tooltip title={intl.formatMessage({id:'homePage.tooltip.reservedBoats'})}> */}
                    <MDBox
                      sx={{
                        width: "50%",
                        display: "flex", flexDirection: "row",
                        justifyContent: "center",
                        fontSize: "0.875rem", fontWeight: "400",
                        color: "#1D1C1B",
                      }}
                    >
                      {container.boats.reserved}
                    </MDBox>
                  {/* </Tooltip> */}

                </MDBox>

              </MDBox>
              );
            })}
          
          </MDBox>
        </MDBox>
        
        {/* Legend */}
        <MDBox
          sx={{
            display: "flex", flexDirection: "column",
          }}
        >
          <MDBox
            sx={{
              display: "flex", flexDirection: "row",
              gap: "1.2rem",
            }}
          >

            {/* containers */}
            <MDBox
              sx={{
                display: "flex", flexDirection: "row",
                alignItems: "flex-start", gap: "0.5rem",
              }}
            >
              <MDBox>
                {containerDoorGreyIcon}
              </MDBox>
              <MDBox
                sx={{
                  display: "flex", flexDirection: "column",
                }}
              >
                <MDBox
                  sx={{
                    display: "flex", flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <MDBox
                    sx={{
                      // width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <MDBox
                      sx={{
                        width: "0.75rem", height: "0.75rem",
                        borderRadius: "50%", backgroundColor: "#F5A524",
                      }}
                    />
                  </MDBox>

                  <MDTypography
                    sx={{
                      fontSize: "0.75rem", fontWeight: "700",
                      color: "#807E7B", paddingLeft: "0.5rem"
                    }}
                  >
                    {intl.formatMessage({id:'tableContainers.tooltip.doorWarningHomePage'})}
                  </MDTypography>
                </MDBox>

                <MDBox
                  sx={{
                    display: "flex", flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <MDBox
                    sx={{
                      // width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <MDBox
                      sx={{
                        width: "0.75rem", height: "0.75rem",
                        borderRadius: "50%", backgroundColor: "#309B0A",
                      }}
                    />
                  </MDBox>

                  <MDTypography
                    sx={{
                      fontSize: "0.75rem", fontWeight: "700",
                      color: "#807E7B", paddingLeft: "0.5rem"
                    }}
                  >
                    {intl.formatMessage({id:'tableContainers.tooltip.doorSuccess'})}
                  </MDTypography>
                </MDBox>

                <MDBox
                  sx={{
                    display: "flex", flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <MDBox
                    sx={{
                      // width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <MDBox
                      sx={{
                        width: "0.75rem", height: "0.75rem",
                        borderRadius: "50%", backgroundColor: "#7B809A",
                      }}
                    />
                  </MDBox>

                  <MDTypography
                    sx={{
                      fontSize: "0.75rem", fontWeight: "700",
                      color: "#807E7B", paddingLeft: "0.5rem"
                    }}
                  >
                    {intl.formatMessage({id:'tableContainers.tooltip.unknown'})}
                  </MDTypography>
                </MDBox>

              </MDBox>
            </MDBox>
              
            {/* signal */}
            <MDBox
              sx={{
                display: "flex", flexDirection: "row",
                alignItems: "flex-start", gap: "0.5rem",
              }}
            >
              <MDBox>
                {signalIcon}
              </MDBox>
              <MDBox
                sx={{
                  display: "flex", flexDirection: "column",
                }}
              >
                {/* online */}
                <MDBox
                  sx={{
                    display: "flex", flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <MDBox
                    sx={{
                      // width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <MDBox
                      sx={{
                        width: "0.75rem", height: "0.75rem",
                        borderRadius: "50%", backgroundColor: "#309B0A",
                      }}
                    />
                  </MDBox>

                  <MDTypography
                  
                    sx={{
                      fontSize: "0.75rem", fontWeight: "700",
                      color: "#807E7B", paddingLeft: "0.5rem"
                    }}
                  >
                    {intl.formatMessage({id:'homePage.tooltip.onlineSignal'})}
                  </MDTypography>
                </MDBox>

                {/* offline */}
                <MDBox
                  sx={{
                    display: "flex", flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <MDBox
                    sx={{
                      // width: "50%",
                      display: "flex", flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <MDBox
                      sx={{
                        width: "0.75rem", height: "0.75rem",
                        borderRadius: "50%", backgroundColor: "#DD2626",
                      }}
                    />
                  </MDBox>

                  <MDTypography
                    sx={{
                      fontSize: "0.75rem", fontWeight: "700",
                      color: "#807E7B", paddingLeft: "0.5rem"
                    }}
                  >
                    {intl.formatMessage({id:'homePage.tooltip.offlineSignal'})}
                  </MDTypography>
                </MDBox>
              </MDBox>

            </MDBox>
          </MDBox>
            
          {/* num of kayaks */}
          <MDBox
            sx={{
              display: "flex", flexDirection: "row",
              marginTop: "0.8rem",
            }}
          >
            {kayakIcon}
            <MDTypography
              sx={{
                fontSize: "0.75rem", fontWeight: "700",
                color: "#807E7B", paddingLeft: "0.5rem"
              }}
            >
              {intl.formatMessage({id:'homePage.legend.numOfKayaks'})}
            </MDTypography>
          </MDBox>
          
          {/* num of reservation kajaks */}
          <MDBox
            sx={{
              display: "flex", flexDirection: "row",
              marginTop: "0.8rem", alignItems: "center",
            }}
          >
            {reservationIconGrey}
            <MDBox>
              <MDTypography
                sx={{
                  fontSize: "0.75rem", fontWeight: "700",
                  color: "#807E7B", paddingLeft: "0.5rem"
                }}
              >
                {intl.formatMessage({id:'homePage.legend.reservations'})}
              </MDTypography>
              <MDTypography
                sx={{
                  fontSize: "0.75rem", fontWeight: "700",
                  color: "#807E7B", paddingLeft: "0.5rem"
                }}
              >
                {intl.formatMessage({id:'homePage.legend.numOfKayaksReservations'})}
              </MDTypography>
            </MDBox>
          </MDBox>

        </MDBox>
      </MDBox>
    </MDBox>        
  )
}

export default injectIntl(HomePage);